import {
  Alert,
  Box,
  Button,
  Card,
  Grid,
  Paper,
  SelectChangeEvent,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography
} from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from 'src/hooks/useAuth';
import { Address } from '../../../interface/interface';
import { OrderWizard } from './OrderWizard';

import { useOrderManagementStore } from '../../../zustandStore/store.ordermgt';

interface OrderManagementProps {}

interface NewAddressForm {
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

const steps = ["Buyer's Details", 'Contact Details', 'Variant', 'Summary'];

const OrderManagementContent: FC<OrderManagementProps> = (
  props: OrderManagementProps
) => {
  const orderStore = useOrderManagementStore((state) => state);
  const [openModal, setOpenModal] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);

  const storeActions = orderStore.actions;
  let currentAction = orderStore.settings.action;

  console.log('Current', activeStep);

  useEffect(() => {
    console.log('Order Management Header', orderStore.settings);
    if (!currentAction) {
      return;
    }
    if (orderStore.settings.action === 'nextStep') {
      handleNext();
    } else if (orderStore.settings.action === 'previousStep') {
      handleBack();
    }
  }, [orderStore.settings.action]);

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    orderStore.actions.setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    orderStore.actions.setActiveStep(activeStep - 1);
  };

  const handleCreateOrder = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Form 2: Select Buyer Address from dropdown or create new address
  const addressForm = () => {
    return (
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            mt: 5,
            gap: 2
          }}
        >
          <Button
            onClick={(e) => {
              storeActions.setActionCommand('previousStep');
            }}
            variant={'contained'}
          >
            Previous
          </Button>
          <Button
            onClick={(e) => {
              storeActions.setActionCommand('nextStep');
            }}
            variant={'contained'}
          >
            Next
          </Button>
        </Box>
      </Box>
    );
  };

  // Form 3: Empty Content (placeholder for future implementation)
  const renderEmptyForm3 = () => {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Form 3
        </Typography>
        <Paper sx={{ p: 3, backgroundColor: '#f5f5f5' }}>
          <Typography variant="body1" align="center">
            Empty Content (Form 3)
          </Typography>
        </Paper>
      </Box>
    );
  };

  // Form 4: Empty Content (placeholder for future implementation)
  const renderEmptyForm4 = () => {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Form 4
        </Typography>
        <Paper sx={{ p: 3, backgroundColor: '#f5f5f5' }}>
          <Typography variant="body1" align="center">
            Empty Content (Form 4)
          </Typography>
        </Paper>

        {/* Add submit button on the final step */}
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
          <Button variant="contained" color="primary" size="large">
            Submit Order
          </Button>
        </Box>
      </Box>
    );
  };

  return (
    <Card
      sx={{
        p: 2
      }}
    >
      <OrderWizard
        onNext={() => handleNext()}
        onBack={() => handleBack()}
        currentStep={activeStep}
      >
        <Grid
          container
          sx={{
            width: '100%'
          }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid
            item
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'center'}
            sx={{
              gap: '3px',
              width: '60%'
            }}
          >
            <Stepper
              activeStep={activeStep}
              sx={{
                padding: '1% 1%',
                borderRadius: '8px',
                border: '1px solid #d8d8d8',
                width: '100%'
              }}
            >
              {steps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: {
                  optional?: React.ReactNode;
                } = {};

                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Grid>
        </Grid>
      </OrderWizard>
    </Card>
  );
};

export default OrderManagementContent;
